import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/lead';

export class LeadsService extends RestServiceConnection {

    /**
     * Lista todos los leads con filtros opcionales
     */
    listLeads = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: { ...filters }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene un lead específico por ID
     */
    getLead = async (leadId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { leadId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Crea un nuevo lead
     */
    createLead = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: values
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Edita un lead existente
     */
    editLead = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: values
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Elimina un lead por ID
     */
    deleteLead = async (leadId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { leadId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Elimina múltiples leads
     */
    deleteMultipleLeads = async (leadIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { leadIds }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene el historial de actividades de un lead
     */
    getLeadActivitiesHistory = async (leadId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-lead-activities-history',
            data: { leadId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene los estados disponibles para leads
     */
    getLeadStatuses = async (productTypeId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-statuses',
            data: { productTypeId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Cambia el estado de un lead
     */
    changeLeadStatus = async (leadId: string, statusId: string, comment?: string, koReasonId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: {
                leadId,
                statusId,
                ...(comment && { comment }),
                ...(koReasonId && { koReasonId })
            }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Cambia el estado de múltiples leads
     */
    multiChangeLeadStatus = async (leadIds: string[], statusId: string, comment?: string, koReasonId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/multi-change-status',
            data: {
                leadIds,
                statusId,
                ...(comment && { comment }),
                ...(koReasonId && { koReasonId })
            }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene el historial de cambios de estado de un lead
     */
    getLeadStatusesHistory = async (leadId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-lead-statuses-history',
            data: { leadId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene los comentarios de un lead
     */
    getLeadComments = async (leadId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-comments',
            data: { leadId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Agrega un comentario a un lead
     */
    addLeadComment = async (leadId: string, comment: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-comment',
            data: { leadId, comment }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Elimina un comentario de un lead
     */
    deleteLeadComment = async (commentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-comment',
            data: { commentId }
        }, true) as AxiosResponse;
        return this;
    }

}